import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Box, Flex, Text } from "@chakra-ui/react";
import { ToDoCard } from "./ToDoCard";
import type { Consultation } from "sdk/consultations";
import type { DiagnosticUser } from "sdk/diagnosticUser";
import type { LabTest } from "sdk/labTests";

interface Props {
  diagnosticUser: DiagnosticUser;
  labTests: LabTest[];
  consultations: Consultation[];
}

export const ToDoCards: FC<Props> = ({ diagnosticUser, labTests }) => {
  const { t } = useTranslation();

  const filteredLabTests = labTests?.filter(
    (labTest) => labTest.status === "completed",
  );

  if (!filteredLabTests || filteredLabTests.length === 0) {
    return (
      <Box w="full" px={8} textAlign="center" borderRadius="md">
        <Text color="black" fontSize="lg">
          {t("diagnosticDashboard.todo.empty")}
        </Text>
      </Box>
    );
  }

  return (
    <Flex direction="column" gap={4} w="full">
      {filteredLabTests.map((labTest) => (
        <ToDoCard
          key={labTest.id}
          labTest={labTest}
          userName={`${diagnosticUser?.firstName || ""} ${diagnosticUser?.lastName || ""}`.trim()}
        />
      ))}
    </Flex>
  );
};
